module.exports = __webpack_public_path__ + "static/img/20.33adca7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners/20.png
// module id = TBbx
// module chunks = 1